// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import XngZone from "@guestsupply/App/Components/Common/XngZone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Page from "@insite/mobius/Page";
import * as React from "react";

const enum fields {
    title = "title",
    content = "content",
    featuredProducts = "featuredProducts",
    image = "image",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.content]: string;
        [fields.featuredProducts]: string;
        [fields.image]: string;
    };
}

type Props = PageProps & OwnProps;

export interface SolutionPageStyles {}
export const SolutionPageStyles: SolutionPageStyles = {};
const styles = SolutionPageStyles;

const SolutionPage: React.FunctionComponent<Props> = ({ id, fields }) => {
    return (
        <Page
            data-test-selector="solutions"
            fullWidth={fields.isFullWidth ? [true, true, true, true, true] : undefined}
        >
            <XngZone contentId={id} zoneName="Content Section" hint="Content Section" />
        </Page>
    );
};
const pageModule: PageModule = {
    component: SolutionPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: false,
        pageType: "Content",
        fieldDefinitions: [
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            HideHeader,
            HorizontalRule,
            MetaDescription,
            MetaKeywords,
            StructuredPageData,
            {
                name: fields.title,
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.content,
                defaultValue: "",
                editorTemplate: "RichTextField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.image,
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: fields.featuredProducts,
                defaultValue: "",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                isRequired: true,
            },
            {
                name: "isFullWidth",
                displayName: "Full Width",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};
export default pageModule;
/**
 * @deprecated Use string literal "SolutionPage" instead of this constant.
 */
export const SolutionPageContext = "SolutionPage";
